@if (label) {
  <label>{{label}}</label>
}
<div class="form-input" [class.error]="!!errorMessage">
  <div class="row">
    @for (option of options; track option) {
      <div class="col-12"
        [class.col-sm-12]="columns == 1"
        [class.col-sm-6]="columns == 2"
        [class.col-sm-4]="columns == 3">
        <div class="form-check">
          <label>
            <input type="checkbox"
              (change)="updateSelection(option[optionValue]); inputChange()"
              [checked]="inSelection(option[optionValue])"
              [name]="id"
              [value]="option[optionValue]"
              [disabled]="disabled"
              [readonly]="readonly"
              [class.has-error]="!!errorMessage"/>
            @if (optionLabelTranslate) {
              <span class="label"> {{(option[optionLabel]| trans)}}</span>
            }
            @if (!optionLabelTranslate) {
              <span class="label">{{option[optionLabel]}}</span>
            }
          </label>
        </div>
      </div>
    }
  </div>
  @if (errorMessage) {
    <div class="form-input-validation">
      <div class="form-input-notes-left">{{(errorMessage | trans)}}</div>
    </div>
  }
</div>



